<nb-card class="own-scroll">
  <nb-card-header
    >{{ header }}
    <button
      class="cancel"
      nbButton
      outline
      status="info"
      size="small"
      (click)="cancel()"
    >
      <nb-icon icon="close-outline"></nb-icon></button
  ></nb-card-header>
  <nb-card-body>
    <div class="form-inline">
      <nb-form-field fullWidth>
        <nb-icon nbPrefix icon="search-outline" pack="eva"></nb-icon>
        <input
          type="text"
          nbInput
          fullWidth
          class="form-control"
          placeholder="Tìm theo tên"
          [(ngModel)]="strSearch"
          (change)="onSearch()"
        />
      </nb-form-field>
    </div>
    <nb-list>
      <nb-list-item *ngFor="let item of displays" class="contact">
        <div>
          <h6 class="text-primary">{{ item.title }}</h6>
          Số câu hỏi: {{ item.noQuiz | number }}
        </div>
        <button
          nbButton
          shape="round"
          outline
          status="success"
          size="small"
          [disabled]="submitted"
          [class.btn-pulse]="submitted"
          (click)="selected(item)"
        >
          <nb-icon icon="checkmark-outline"></nb-icon>
        </button>
      </nb-list-item>
    </nb-list>
  </nb-card-body>
  <nb-card-footer *ngIf="linkExerciseId != ''">
    <button
      nbButton
      shape="round"
      outline
      status="danger"
      size="small"
      [disabled]="submitted"
      [class.btn-pulse]="submitted"
      (click)="removeLink()"
    >
      <nb-icon icon="trash-2-outline"></nb-icon>
      <span>Xóa liên kết bài tập</span>
    </button>
  </nb-card-footer>
</nb-card>
